import React, { useState } from 'react';
import { Layout } from './components/Layout';
import { machineData } from './data/machineData';
import { PinEntry } from './components/PinEntry';
export function App() {
  const [selectedMachine, setSelectedMachine] = useState(machineData[0].id);
  const [showMainDashboard, setShowMainDashboard] = useState(false);
  const [isPinVerified, setIsPinVerified] = useState(false);
  const handlePinVerified = () => {
    setIsPinVerified(true);
  };
  if (!isPinVerified) {
    return <PinEntry correctPin="14863" onPinVerified={handlePinVerified} data-id="element-0" />;
  }
  return <div className="w-full min-h-screen bg-gray-900 text-white font-sans" data-id="element-1">
      <Layout selectedMachine={selectedMachine} setSelectedMachine={setSelectedMachine} machineData={machineData} showMainDashboard={showMainDashboard} setShowMainDashboard={setShowMainDashboard} data-id="element-2" />
    </div>;
}